// extracted by mini-css-extract-plugin
export default {"faq":"styles_faq__iDAoa","list":"styles_list__cD1jd","item":"styles_item__Vv58L","q":"styles_q__TTfwL","mark":"styles_mark__RwAwl","a":"styles_a__FJpCh","todo":"styles_todo__hFeQX"};